import { api } from './client.js';

const BASE = '/api/events';

export const eventsApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`${BASE}${qs ? `?${qs}` : ''}`);
  },
  get: (id) => api.get(`${BASE}/${id}`),
  create: (data) => api.post(BASE, data),
  update: (id, data) => api.put(`${BASE}/${id}`, data),
  archive: (id) => api.delete(`${BASE}/${id}`),
};
